export function visibleHomeHeroHeading() {
  const headings = document.querySelectorAll(".home-hero-heading")
  return [...headings].find((heading) => heading.offsetParent !== null) || null
}

export function inHomeHeroSection(navElement, buffer = 12) {
  const hero = document.getElementById("home-hero")
  if (!hero) return false

  const navHeight = navElement?.offsetHeight ?? 0
  return hero.getBoundingClientRect().bottom > navHeight + buffer
}

export function pastHomeHeroHeading(navElement, buffer = 12) {
  const heading = visibleHomeHeroHeading()
  if (!heading) return true

  const navHeight = navElement?.offsetHeight ?? 0
  return heading.getBoundingClientRect().top <= navHeight + buffer
}
